/**
 * Each declared marker's own description, keyed by name.
 *
 * What names a boundary in the author's words rather than by its identifier.
 * Built once from the declaration, so every view that names a marker looks its
 * meaning up the same way.
 */export function markerMeaningsOf(declaration){return new Map((declaration==null?[]:declaration.markers).map(marker=>[marker.name,marker.description]));}